"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINCH_SANDBOX_ACCOUNT_LIMIT = exports.PROVIDER_SANDBOX_CONNECTION_LIMIT = exports.FINCH_SANDBOX_CONNECTION_LIMIT = void 0;
exports.FINCH_SANDBOX_CONNECTION_LIMIT = 100;
exports.PROVIDER_SANDBOX_CONNECTION_LIMIT = 5;
exports.FINCH_SANDBOX_ACCOUNT_LIMIT = 3;
